import React, { useRef } from "react";
import { Box } from "@mui/material";
import {
    SmallCarouselContainer,
    SmallSliderWrapper,
    SmallSlide,
    ArrowButton,
} from "./Styled";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { lojas } from "../../../../constants/HomeCupom/carouselSmall";

export default function CarouselSmall({ items, renderItem }) {
    const sliderRef = useRef(null);

    const scroll = (direction) => {
        const slider = sliderRef.current;
        if (!slider) return;
        const slideWidth = slider.clientWidth;
        slider.scrollBy({
        left: direction === "left" ? -slideWidth : slideWidth,
        behavior: "smooth",
        });
    };
    
    return (
        <SmallCarouselContainer>
            <ArrowButton left onClick={() => scroll("left")} sx={{backgroundColor: "#DDDDDD",
                color: "#9F9999",
                "&:hover": { backgroundColor: "#EEE" },
                boxShadow: 1,
                }}>
                <ArrowBackIosNewIcon />
            </ArrowButton>

            <SmallSliderWrapper ref={sliderRef}>
                {lojas.map((item, i) => (
                    <SmallSlide key={i}>
                    {renderItem ? (
                        renderItem(item, i)
                    ) : !item.logo ? (
                        <Box
                        component="img"
                        src={item.src}
                        alt={item.alt || `slide-${i}`}
                        onClick={() =>
                            window.open(`https://www.meucupom.com/cupom-desconto-${item.slug}`, "_blank")
                        }
                        sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            cursor: "pointer",
                        }}
                        />
                    ) : (
                        <Box
                        sx={{
                            position: "relative",
                            width: "100%",
                            height: "100%",
                            backgroundColor: "var(--c-brand-deep)",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-around",
                            color: "#fff",
                            borderRadius: "8px",
                            p: 2,
                        }}
                        >
                        <Box
                            component="img"
                            src={item.produto}
                            alt="Produto"
                            sx={{ mb: 2 }}
                        />
                        <Box
                            component="img"
                            src={item.logo}
                            alt={item.alt}
                            sx={{
                                maxHeight: "50px",
                                maxWidth: "120px",
                                width: "auto",
                                height: "auto",
                                objectFit: "contain",
                            }}
                        />
                        <Box
                            onClick={() => {
                                if (item.slug) {
                                    window.open(`https://www.meucupom.com/cupom-desconto-${item.slug}`, "_blank");
                                }
                            }}
                            component="button"
                            sx={{
                            backgroundColor: "#E2B433",
                            color: "#0D0E42",
                            fontWeight: "bold",
                            fontSize: "1.7rem",
                            border: "none",
                            borderRadius: "28px",
                            padding: "0.5rem 3rem",
                            cursor: "pointer",
                            }}
                        >
                            Confira
                        </Box>
                        </Box>
                    )}
                    </SmallSlide>
                ))}
            </SmallSliderWrapper>


            <ArrowButton onClick={() => scroll("right")} sx={{backgroundColor: "#DDDDDD",
                color: "#9F9999",
                "&:hover": { backgroundColor: "#EEE" },
                boxShadow: 1,
                }}>
                <ArrowForwardIosIcon />
            </ArrowButton>
        </SmallCarouselContainer>
    );
}
